import { co2 } from './common';

export default {
  'consumption.co2': `${co2} emisii combinate`,
  'consumption.energy': 'Consum de energie în ciclu de test combinat',
  'consumption.fuel': 'Consum de combustibil combinat',
  'footnotes.local': '',
  'footnotes.wltp': `Valorile comunicate au fost stabilite conform procedurilor de măsurare impuse. Este vorba de „valorile ${co2} WLTP“ în sensul art. 2 nr. 3 din Regulamentul de punere în aplicare (UE) 2017/1153. Valorile consumului de combustibil au fost calculate pe baza acestor valori. Consumul de curent a fost determinat pe baza Regulamentului 683/2008/CE. Informațiile nu se referă la un autovehicul individual și nu sunt parte integrantă a ofertei, ci servesc exclusiv în scopul comparației între diferite modele de autovehicule. Valorile variază în funcție de echipările speciale alese.`,
  'footnotes.nedc': '',
  'footnotes.emissions.appendix': `Pentru mai multe informații despre consumul oficial de combustibil și emisiile de ${co2} ale autoturismelor noi, vă rugăm să contactați partenerul dumneavoastră autorizat Mercedes-Benz.`,
  'search.input.label': 'Termenul dumneavoastră de căutare / Configurator OnlineCode',
  'search.result.buy-online': 'Magazin Online',
  'search.results': 'Nu s-au găsit rezultate. | {count} rezultatul căutării | {count} rezultatele căutării',
  'search.results.count': '{count} rezultatele căutării',
  'search.results.backup': 'Nu s-au găsit rezultate exacte. Vizualizați paginile asociate:',
  'search.results.none.summary':
    'Pentru acest termen de căutare nu s-au găsit rezultate. Vă rugăm să încercați din nou cu un alt termen.',
  'search.show-more': 'Arată mai mult',
  'search.unavailable': 'Căutarea nu este disponibilă.',
  'search.result.new': 'Nou',
  'search.result.consumption': 'Consum',

  'input.placeholder': 'Termenul dumneavoastră de căutare / Configurator OnlineCode',

  'suggestions.all_search_results': 'Toate rezultatele căutării',
  'suggestions.all_search_results_for': 'Afișează toate rezultatele pentru',
  'suggestions.in': 'în',

  all: 'Alle',
  UCOS: 'Brugte biler onlinebutik',
  PASSENGER_CARS: 'Personbil',
  VANS: 'MPV',
  NCOS: 'Nye biler onlinebutik',
  VIDEO: 'Videoer',
  DEALER_LOCATOR: 'Forhandlersøgning',
  CONFIGURATOR: 'Configurator',
  TEST_DRIVE: 'Prøvetur',
  VEHICLE_SEARCH: 'Søgning efter brugt bil',
  COLLECT: 'Collection & tilbehør',
  CONNECT: 'Mercedes me Store',
  ACCESSORIES: 'Biltilbehør',

  'watch.video': 'Urmăriți videoclipul',
  'input.recently': 'Căutate recent',
  'input.help.title': 'Ce trebuie să cauți?',
  'input.help.text':
    'Caută folosind modele de autovehicule, coduri de configurare sau de accesorii, alte produse și informații',

  'search.result.grid': 'Grilă',
  'search.result.list': 'Listă',

  // No results
  'support.check':
    'Vă rugăm să verificați dacă există greșeli de ortografie sau să încercați cu un alt termen de căutare.',
  'support.no.results': 'Nu există rezultate ale căutării disponibile pentru acest termen de căutare.',
  'support.no.results.term': 'Nu s-au găsit rezultate',
  'support.chat': 'Nu găsiți ceea ce căutați? Vă rugăm să folosiți varianta noastră de',
  'support.chat.with.us': 'asistență online',

  'search.results.offer': 'Oferte populare pentru "{query}":',
};
